export const ARES_LOADING = 'aresLoading';
export const PERSONAL_INFORMATION = 'personalInformation';
export const FIOC = 'fioc';
export const IDENTIFICATION = 'identification';
export const DOCUMENTATION = 'documentation';
export const STANDBY_LOAN = 'standby-loan';
export const CONTRACTING_LOAN = 'contracting-loan';
export const PENDING_OTP = 'pending-otp';
export const TRANSFER_OTP = 'transfer-otp';
export const RESULT_LOAN_APPROVED = 'result-loan-approved';
export const RESULT_LOAN_COUNTEROFFER = 'result-loan-counteroffer';
export const SUCCESS_LOAN = 'success-loan';
export const SIGNING_CONTRACT = 'contract';
export const INE_LOAN = 'ine-loan';
export const BATCH = 'batch';
export const PRE_CANCELED = 'pre-canceled';
export const SIGNATURE_KEY = 'signature-key';
